import { ControllerDto } from 'src/Libs/flow/installation/api'
import { parseControllerDevice } from '../device-parsers'
import { Htc320hIo } from 'src/Libs/flow/installation/forms'

export const parseHtc320hIo = (io: Nullable<ControllerDto>): Htc320hIo => {
  return {
    ...parseControllerDevice(io),

    nominalPower: io?.outputs?.[0]?.typeParameters?.nominalPower ?? '',

    isConsumptionActive: !!io.inputs?.[0]?.active,

    totalPowerConsumption: io.inputs?.[0]?.value ?? 0,

    isProductionActive: !!io.inputs?.[1]?.active,

    rawData: io,
  }
}
